/*
 * Lead / intent events → GA4 via the Google & YouTube app's gtag (2026-09-26).
 *
 * The Google & YouTube app sends only Shopify's standard ecommerce events and has no
 * custom-event mapping; Google does not support Google tags inside Shopify custom
 * pixels. The app does load the real Google tag in the storefront window, so the
 * theme sends its own events through it:
 *   - only `gtag('event', …)` — never `config` or page_view (the app owns those; a
 *     second config would duplicate page views);
 *   - always `send_to: GA4_ID`, so the events don't also reach the Ads tag;
 *   - if gtag hasn't loaded yet, wait for it (≤ 8 s), then fall back to queueing on
 *     `dataLayer` (drained when gtag.js loads — needs a real `arguments` object).
 * `Shopify.analytics.publish` stays as a fallback channel (Customer Events), in case
 * the app ever stops exposing gtag on the page.
 *
 * GA4 events (all carry page_type, page_path; product_id on product pages):
 *   generate_lead   { lead_type: whatsapp | orcamento | contato, lead_source, link_location }
 *   shipping_quote  { uf, result, rates_count, min_price } — not a lead, not a key event
 *
 * Google Ads: create website conversions in the Ads UI and paste their labels into
 * ADS_LABELS (orcamento = primary, whatsapp = secondary). Do NOT also import these
 * GA4 events into Ads, or each lead counts twice. Empty label = no Ads call.
 *
 * Verify after every deploy: Tag Assistant + GA4 DebugView (docs/lead-events.md).
 */
(function () {
  var GA4_ID = 'G-YRB2BPH72R';
  var ADS_ID = 'AW-1010500938';
  var ADS_LABELS = { orcamento: '', whatsapp: '', contato: '' };

  // The app injects gtag through its web pixel, after DOMContentLoaded — so an event
  // fired on page load (form leads) would otherwise sit in the queue ahead of the app's
  // own `js`/`config`. Wait for gtag (up to GTAG_WAIT_MS), then fall back to the queue.
  var GTAG_WAIT_MS = 8000;
  function withGtag(cb) {
    if (typeof window.gtag === 'function') return cb(window.gtag);
    // Elapsed time, not tick count: background tabs throttle setInterval.
    var start = Date.now();
    var timer = setInterval(function () {
      if (typeof window.gtag === 'function' || Date.now() - start >= GTAG_WAIT_MS) {
        clearInterval(timer);
        if (typeof window.gtag === 'function') return cb(window.gtag);
        window.dataLayer = window.dataLayer || [];
        cb(function () { window.dataLayer.push(arguments); });
      }
    }, 250);
  }

  function context() {
    var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
    var ctx = {
      page_type: (meta.page && meta.page.pageType) || '',
      page_path: location.pathname
    };
    if (meta.product) ctx.product_id = String(meta.product.id);
    return ctx;
  }

  function assign(target, source) {
    for (var k in source) if (Object.prototype.hasOwnProperty.call(source, k)) target[k] = source[k];
    return target;
  }

  // name: GA4 event name. The Shopify custom event mirrors it as `enfoque:<name>`.
  function track(name, data, opts) {
    var params = assign(context(), data || {});
    var ga4 = assign({ send_to: GA4_ID }, params);
    if (opts && opts.beacon) ga4.transport_type = 'beacon';
    var label = opts && opts.adsLabel;
    withGtag(function (g) {
      try {
        g('event', name, ga4);
        if (label) g('event', 'conversion', { send_to: ADS_ID + '/' + label });
      } catch (e) { /* analytics must never break the page */ }
    });
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('enfoque:' + name, params);
      }
    } catch (e) {}
  }
  window.enfoqueTrack = track;

  // Where on the page the link sits: an explicit data-lead-location wins, then
  // header/footer, then the section's type (id minus the template prefix).
  function linkLocation(a) {
    var tagged = a.closest('[data-lead-location]');
    if (tagged) return tagged.getAttribute('data-lead-location');
    if (a.closest('header')) return 'header';
    if (a.closest('footer')) return 'footer';
    var section = a.closest('[id^="shopify-section-"]');
    return section ? section.id.replace(/^shopify-section-(template--\d+__)?/, '') : '';
  }

  // WhatsApp — one delegated listener covers every wa.me / api.whatsapp.com link
  // (header, footer, floating button, institutional blocks, PDP CTAs). Beacon
  // transport so the hit survives the navigation away.
  var WA = /(^|\/\/)(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\//i;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !WA.test(a.getAttribute('href'))) return;
    track('generate_lead', { lead_type: 'whatsapp', lead_source: 'whatsapp_link', link_location: linkLocation(a) },
      { beacon: true, adsLabel: ADS_LABELS.whatsapp });
  }, true);

  // Contact-type forms reload the page with ?contact_posted=true; the Liquid success
  // message carries data-lead-event="<form type>". Fire once, then drop the query
  // param so a refresh doesn't count the lead twice.
  var FORM_LEAD_TYPE = { quote_request: 'orcamento', product_inquiry: 'orcamento', contact_form: 'contato' };
  function formLead() {
    var ok = document.querySelector('[data-lead-event]');
    if (!ok || !/[?&]contact_posted=true/.test(location.search)) return;
    var source = ok.getAttribute('data-lead-event');
    var type = FORM_LEAD_TYPE[source] || 'contato';
    track('generate_lead', { lead_type: type, lead_source: source }, { adsLabel: ADS_LABELS[type] });
    try {
      var url = new URL(location.href);
      url.searchParams.delete('contact_posted');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', formLead);
  else formLead();
})();
